import React, { Component } from "react";
import { Route } from "react-router-dom";

const WebSurveyLayout = ({ children }) => <>{children}</>;

const MyWebSurveyRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <WebSurveyLayout>
          <Component {...matchProps} />
        </WebSurveyLayout>
      )}
    />
  );
};

export default MyWebSurveyRoute;
